export default {
      id: "icon-stage-usage",
      viewBox: "0 0 17.067 14.629",
      url: __webpack_public_path__ + "img/icons.c8a27ec6.svg#icon-stage",
      toString: function () {
        return this.url;
      }
    }